export default __webpack_public_path__ + "static/media/step_11_successfully_added.1ae563ee.png";